import React, { Component } from "react";
import {
  WithStyles,
  Typography,
  TableHead,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Modal,
  Grid,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import { CheckCircle, InfoOutlined as InfoIcon } from "@material-ui/icons";
import { ContentEvaluation } from "../types/Constants";
import RequestReviewContainer from "../containers/RequestReviewContainer";
import { userStyles } from '../styles';
import _ from "lodash";
import moment from "moment";
import { setQuestionData } from '../helper/setQuestionData';
import { setTestData } from '../helper/setTestData';
import { contentRequestAccordianActions } from '../reducers/contentRequestAccordianState';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { extractContent } from "../../../utils";
//@ts-ignore
interface YourTaskListingProps extends WithStyles<typeof userStyles> {
  questionData: any;
  testData: any;
  classes: any;
  contentType: string;
  contentRequestId: string;
  authorType: string;
  testCount: number;
  setActiveTabInParent: Function;
  updateData: Function;
  authorDeadline: string;
  totalCount: number;
  overallDone: any;
  setOverallStatus: Function;
  setIsBothTabOpen: Function;
  setType: Function;
  setAccordingTouchIndex: Function;
  isTabOpened: any;
}

interface YourTaskListingStates {
  //   isOpenYourTaskListingDialog: boolean;
  activeType: string;
  showRequestContainer: boolean;
  sliderData: any;
  selectedContentId: string,
  currentQuestionNumber: number,
  currentTestNumber: number,
  contentQuestionType: string,
  contentQuestionCode: string,
  fromURL: string,
  showTooltip: boolean,
  selectedHoverQuestion: string,
  isTestRequest: boolean,
}

class YourTaskListing extends Component<
  YourTaskListingProps,
  YourTaskListingStates
  > {
  constructor(props: YourTaskListingProps) {
    super(props);
    this.state = {
      activeType: 'Question',
      showRequestContainer: false,
      sliderData: {},
      selectedContentId: '',
      currentQuestionNumber: 1,
      currentTestNumber: 1,
      contentQuestionType: '',
      contentQuestionCode: '',
      fromURL: 'preview',
      showTooltip: false,
      selectedHoverQuestion: '',
      isTestRequest: false,
    }
    this.getSecondaryConceptsTagged = this.getSecondaryConceptsTagged.bind(this);
    this.checkStatus = this.checkStatus.bind(this);
    this.checkTestStatus = this.checkTestStatus.bind(this);
    this.checkAuthorType = this.checkAuthorType.bind(this);
    this.contentChanged = this.contentChanged.bind(this);
    this.closeReviewContainer = this.closeReviewContainer.bind(this);
    this.checkButtonText = this.checkButtonText.bind(this);
    this.checkForContentComplete = this.checkForContentComplete.bind(this);
    this.getTooltipValue = this.getTooltipValue.bind(this);
  }


  // componentDidMount11(){
  //   // const { testDetails: { type = '', assignor = {} } = {}, totalCount = 0, type: formatType, requestId, accordianState, contentRequestData, progressBar } = this.props;
  //   // const { questionsData, contentType, testData, contentRequestId, authorType, testCount } = this.props;
  //   // let check = this.props.type;
  //   // let filterArray: any = [];
  //   // this.props.questionData.forEach((val: any) => {
  //   //     const { questions = [] } = val;
  //   //     questions.forEach((val: any) => {
  //   //         filterArray.push(val);
  //   //     })
  //   // })
  //   // const len = filterArray;
  //   // if (len.length && check === 'test' && Object.keys(assignor).length !== 0) {
  //   //     check = 'both';
  //   // }
  // }

  componentWillMount = () => {
    const { setAccordingTouchIndex, questionData, isTabOpened } = this.props;
    setTimeout(() => {
      if (!isTabOpened) {
        const { setAccordingTouchIndex, questionData = [] } = this.props;
        let accordianArray: any = []
        let index = 0;
        questionData && questionData.forEach((val: any) => {
          const { questions = [] } = val;
          questions.forEach(() => {
            const quesArray = {
              accordianIndex: index,
              questionContent: []
            }
            accordianArray.push(quesArray);
            index = index + 1;
          })
        })
        setAccordingTouchIndex(accordianArray);
      }

    }, 1000)

  }

  componentDidMount() {
    // if(nextProps.testData !== this.props.testData && 
    //   nextProps.contentType !== this.props.contentType &&
    //   nextProps.questionData !== this.props.questionData){
    const { assignor } = this.props.testData;
    let check = this.props.contentType;

    let filterArray: any = [];
    this.props.questionData.forEach((val: any) => {
      const { questions = [] } = val;
      questions.forEach((val: any) => {
        filterArray.push(val);
      })
    })

    const len = filterArray;
    if (len.length && check === 'test' && Object.keys(assignor).length !== 0) {
      check = 'both';
    }

    setTimeout(() => {
      const { questionData = [], totalCount = 0,
        setIsBothTabOpen,
        setOverallStatus
      } = this.props;
      if (check === "both") {
       
        setQuestionData(this.props, check);
        setTestData(this.props, totalCount, check);
        this.setState({ isTestRequest: false }, () => {
          setIsBothTabOpen({ booleanValue: true })
          this.props.setType({ type: this.state.activeType })
        })
        // setIsBothTabOpen({ booleanValue: true })
        this.props.setType({ type: this.state.activeType })

      } else if (filterArray && filterArray.length) {
        setQuestionData(this.props, check);
        this.setState({ isTestRequest: false });
      } else {
        setTestData(this.props, totalCount, check);
        this.setState({ isTestRequest: true })
      }
      setOverallStatus({ booleanValue: this.props.overallDone })
    }, 1000);

    //}
  }

  handleHover(event: any) {
    this.setState({
      showTooltip: !this.state.showTooltip,
      selectedHoverQuestion: event.target.id
    })
  }
  setActiveTab(event: any) {
    this.props.setActiveTabInParent(event.target.id)
    this.setState({
      activeType: event.target.id
    })
  }
  openReviewQuestionPage(question: any) {
    if (this.checkForContentComplete(question)) {
      this.setState({
        showRequestContainer: true,
        sliderData: question.contentRequestItemsId,
        selectedContentId: `${question.contentRequestItemsId.contents[0].content_id._id}question`,
        contentQuestionType: 'question',
        contentQuestionCode: question.code

      })
    }
  }

  openReviewTestPage(test: any) {
    if (this.checkForContentComplete(test)) {

      this.setState({
        showRequestContainer: true,
        sliderData: test.contentRequestItemsId,
        selectedContentId: `${test.contentRequestItemsId.contents[0].content_id._id}testpapers`
      })
    }
  }

  closeReviewContainer() {
    this.setState({
      showRequestContainer: false,
      sliderData: {},
      selectedContentId: '',
      currentQuestionNumber: 1,
      currentTestNumber: 1,
      fromURL: 'preview',
    })
    this.props.updateData();
  }
  checkAuthorType() {
    if (this.props.authorType === "evaluator") {
      return 'Evaluation'
    } else if (this.props.authorType === "moderator") {
      return 'Moderation'
    } else
      if (this.props.authorType === "languageEvaluator") {
        return 'Language Evaluation'
      } else {
        return 'Publish'
      }
  }
  checkForContentComplete(data: any) {
    if (this.props.authorType === "evaluator") {
      return data && data.contentRequestItemsId && data.contentRequestItemsId.overallStatus.creator.isJobCompleted
    } else if (this.props.authorType === "languageEvaluator") {
      return data && data.contentRequestItemsId && data.contentRequestItemsId.overallStatus.evaluator.isJobCompleted
    } else
      if (this.props.authorType === "moderator") {
        return data && data.contentRequestItemsId && data.contentRequestItemsId.overallStatus.languageEvaluator.isJobCompleted
      } else {
        return data && data.contentRequestItemsId && data.contentRequestItemsId.overallStatus.moderator.isJobCompleted
      }
  }
  contentChanged(contentId: string, numberValue: number, type: string, fromURL: string) {
    if (type === 'question') {
      this.setState({
        selectedContentId: contentId,
        currentQuestionNumber: numberValue,
        fromURL: fromURL
      })
    } else {
      this.setState({
        selectedContentId: contentId,
        currentTestNumber: numberValue,
        fromURL: fromURL
      })
    }

  }

  checkStatus(question: any) {
    let isJobCompleted = 0;

    question && question.contentRequestItemsId && question.contentRequestItemsId.contents.forEach((content: any) => {
      if (content.status[this.props.authorType].isJobCompleted) {
        isJobCompleted = isJobCompleted + 1;
      }
    })
    if (isJobCompleted === 0 && _.get(question, 'contentRequestItemsId.totalFeedbackCountOfUser', 0) === 0) {
      return <span>Not Yet Started</span>
    } else if (isJobCompleted === question.count) {
      return <CheckCircle />
    } else {
      return <span>In Progress {isJobCompleted}/{question.count}</span>
    }

  }

  getTooltipValue(data: any, type: string) {
    let { authorType } = this.props
    if (authorType === "evaluator") {
      return 'Yet to be Created'
    } else if (authorType === "moderator") {
      return 'Yet to be Language Evaluated'
    } else
      if (authorType === "languageEvaluator") {
        return 'Yet to be Evaluated'
      } else {
        return 'Yet to be Moderated'
      }
  }

  getReviewButtonText() {
    let { authorType } = this.props
    if (authorType === "evaluator") {
      return 'Evaluate'
    } else if (authorType === "moderator") {
      return 'Moderate'
    } else
      if (authorType === "languageEvaluator") {
        return 'Lang. Evaluate'
      } else {
        return 'Publish'
      }
  }
  checkButtonText(data: any, type: string) {
    let isJobCompleted = 0;
    if (type === "question") {
      data && data.contentRequestItemsId && data.contentRequestItemsId.contents.forEach((content: any) => {
        if (content.status[this.props.authorType].isJobCompleted) {
          isJobCompleted = isJobCompleted + 1;
        }
      })
      if (isJobCompleted === 0 || isJobCompleted === data.count) {
        return this.getReviewButtonText();
      } else {
        return 'Resume'
      }
    } else {
      data && data.contentRequestItemsId && data.contentRequestItemsId.contents.forEach((content: any) => {
        if (content.status[this.props.authorType].isJobCompleted) {
          isJobCompleted = isJobCompleted + 1;
        }
      })
      if (isJobCompleted === 0 || isJobCompleted === this.props.testCount) {
        return this.getReviewButtonText();
      } else {
        return 'Resume'
      }
    }
  }

  checkTestStatus(test: any) {
    let isJobCompleted = 0;

    test && test.contentRequestItemsId && test.contentRequestItemsId.contents.forEach((content: any) => {
      if (content.status[this.props.authorType].isJobCompleted) {
        isJobCompleted = isJobCompleted + 1;
      }
    })
    if (isJobCompleted === 0 && _.get(test, 'contentRequestItemsId.totalFeedbackCountOfUser', 0) === 0) {
      return <span>Not Yet Started</span>
    } else if (isJobCompleted === this.props.testCount) {
      return <CheckCircle />
    } else {
      return <span>In Progress {isJobCompleted}/{this.props.testCount}</span>
    }

  }

  getSecondaryConceptsTagged(content: any) {
    const data = content && content.subjects && content.subjects.reduce((acc: string[], subject: any) => {
      const { checked: subjectCheck, subSubjects, subjectId } = subject;
      if (!subjectId) {
        return acc;
      }
      if (subjectCheck || subjectId.checked) {
        acc.push(subjectId.name);
        return acc;
      }
      for (let subSubject of subSubjects) {
        const { checked: subSubjectCheck, chapters, subSubjectId } = subSubject;
        if (!subSubjectId) {
          continue;
        }
        if (subSubjectId.checked || subSubjectCheck) {
          acc.push(subSubjectId.name);
          continue;
        }
        for (let chapter of chapters) {
          const { checked: chapterCheck, concepts, chapterId } = chapter;
          if (!chapterId) {
            return "";
          }
          if (chapterId.checked || chapterCheck) {
            acc.push(chapterId.name);
            continue;
          }
          for (let concept of concepts) {
            const { checked: conceptCheck, conceptId } = concept;
            if (!conceptId) {
              return "";
            }
            if (conceptId.checked || conceptCheck) {
              acc.push(conceptId.name);
              continue;
            }
          }
        }
      }
      return acc;
    }, []);
    return data && data.join(", ");
  };

  checkForQuestionCompletion() {
    let isTabActive = true;
    this.props.questionData.forEach((questions: any) => {
      questions && questions.questions.forEach((question: any, index: number) => {
        if (question.contentRequestItemsId && question.contentRequestItemsId.overallStatus[this.props.authorType].isJobCompleted) {
          isTabActive = isTabActive && true
        } else {
          isTabActive = false
        }
      });
    });
    return isTabActive;
  }

  render() {
    let i = 0;
    const { classes, questionData, contentType, testData, contentRequestId, authorType, testCount } = this.props;
    const { activeType, showRequestContainer, sliderData, selectedContentId, currentQuestionNumber, currentTestNumber, contentQuestionCode, contentQuestionType, fromURL, showTooltip, selectedHoverQuestion } = this.state;
    return (
      <>
        {contentType === "both" && (
          <>
            <Typography
              className={`${activeType === ContentEvaluation.contentEvaluation ? 'activeTab' : ''} subPanel `}
              id={ContentEvaluation.contentEvaluation}
              onClick={(e) => {
                this.setActiveTab(e);
              }}
            >
              {ContentEvaluation.contentEvaluation}&nbsp;{this.checkAuthorType()}
            </Typography>{" "}
            <Grid className={classes.verticleLine}></Grid>
            <Typography
              id={ContentEvaluation.testEvaluation}
              className={`${activeType === ContentEvaluation.testEvaluation ? 'activeTab' : ''} subPanel ${!this.checkForQuestionCompletion() ? classes.disableTab : ''} `}
              onClick={(e) => {
                this.setActiveTab(e);
              }}
            >
              {ContentEvaluation.testEvaluation}&nbsp;{this.checkAuthorType()}
            </Typography>
          </>
        )}
        {activeType === ContentEvaluation.contentEvaluation && (
          <>
            <Table className={classes.yourTaskTable}>
              <TableHead>
                <TableRow>
                  <TableCell>S.No.</TableCell>
                  <TableCell>Count</TableCell>
                  <TableCell>Question Type</TableCell>
                  <TableCell>
                    Syllabus for the content
                    <CustomInfoIcon
                      infoDialogContentType="Add Syllabus for the content"
                      isInfoIcon={true}
                      isRightArrow={false}
                      isCenterArrow={true}
                      knowMoreAbout={false}
                      dialogTitle="Add Syllabus for the content"
                      imageURL="/assets/svg/contentRequest/syllabusIcon.svg"
                      dialogPara="In this column you have to tag relevant syllabus of the content as per the requirement."
                      details="Click to know more"
                      toolTipDirection="top"
                    />
                  </TableCell>
                  <TableCell>Additional Description</TableCell>
                  <TableCell>Deadline</TableCell>
                  <TableCell className={classes.textCenter}>Status</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {questionData &&
                  questionData.map((subjectQuestion: any, indexSub: number) => {
                    return subjectQuestion && subjectQuestion.questions.map((question: any, index: number) => {
                      return (
                        <>
                          <span className={classes.dNone} >{i = i + 1}</span>
                          <TableRow>
                            <TableCell>{i}</TableCell>
                            <TableCell>{question.count}</TableCell>
                            <TableCell>{question.type}</TableCell>
                            <TableCell>
                            <div className={classes.addtionalDes}>
                              {this.getSecondaryConceptsTagged(question.syllabus)}
                            </div>
                            </TableCell>
                            <TableCell>
                                <div className={classes.addtionalDes} dangerouslySetInnerHTML={{ __html: question.description }}>
                                  
                                </div>
                            </TableCell>
                            <TableCell>{moment(this.props.authorDeadline).format('Do MMM')}</TableCell>
                            <TableCell className={classes.textCenter}>
                              {this.checkStatus(question)}
                            </TableCell>
                            <TableCell
                              id={question && question._id}
                              onMouseOver={this.handleHover.bind(this)}
                              onMouseOut={this.handleHover.bind(this)}
                              className={!this.checkForContentComplete(question) ? classes.disable : ''}
                              onClick={(e: any) => {
                                this.openReviewQuestionPage(question);
                              }}
                            >{this.checkButtonText(question, 'question')}
                              {!this.checkForContentComplete(question) &&
                                <span className={classes.tooltipDetails}>
                                  {
                                    showTooltip && selectedHoverQuestion === question._id &&
                                    <>
                                      <CustomInfoIcon
                                        isInfoIcon={false}
                                        isCenterArrow={false}
                                        isRightArrow={showTooltip}
                                        details={this.getTooltipValue(question, 'question')}
                                        toolTipDirection="right" />
                                    </>
                                  }

                                </span>
                              }
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })
                  })}
              </TableBody>
            </Table>
          </>
        )}
        {activeType === ContentEvaluation.testEvaluation && (
          <>
            <Table className={classes.tableBg}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.textCenter}>S.No.</TableCell>
                  <TableCell className={classes.textCenter}>Count</TableCell>
                  <TableCell className={classes.textCenter}>Test Type</TableCell>
                  <TableCell className={classes.textCenter}>Additional Description</TableCell>
                  <TableCell className={classes.textCenter}>Status</TableCell>
                  <TableCell className={classes.textCenter}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {testData &&
                  <TableRow>
                    <TableCell>{1}</TableCell>
                    <TableCell>{testCount}</TableCell>
                    <TableCell>{testData.type}</TableCell>
                    <TableCell>
                     <div className={classes.addtionalDes}> {testData.name}</div>
                      </TableCell>
                    <TableCell className={classes.textCenter}>
                      {this.checkTestStatus(testData)}
                    </TableCell>
                    <TableCell
                      id="test"
                      onMouseOver={this.handleHover.bind(this)}
                      onMouseOut={this.handleHover.bind(this)}
                      className={!this.checkForContentComplete(testData) ? classes.disable : ''}
                      onClick={(e: any) => {
                        this.openReviewTestPage(testData);
                      }}
                    >
                      {this.checkButtonText(testData, 'test')}
                      {!this.checkForContentComplete(testData) &&
                        <span className={classes.tooltipDetails}>
                          {
                            showTooltip &&
                            <>
                              <CustomInfoIcon
                                isInfoIcon={false}
                                isCenterArrow={false}
                                isRightArrow={showTooltip}
                                details={this.getTooltipValue(testData, 'test')}
                                toolTipDirection="right" />
                            </>
                          }

                        </span>
                      }
                    </TableCell>
                  </TableRow>
                }
              </TableBody>
            </Table>
          </>
        )}
        {showRequestContainer &&
          <Modal
            open={true}
            classes={{ root: classes.fullModal }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            hideBackdrop={true}
          >
            <RequestReviewContainer contentRequestId={contentRequestId} contentId={selectedContentId}
              sliderData={sliderData} currentQuestionNumber={currentQuestionNumber}
              contentChanged={this.contentChanged} closeReviewContainer={this.closeReviewContainer}
              authorType={authorType}
              currentTestNumber={currentTestNumber} contentQuestionType={contentQuestionType}
              contentQuestionCode={contentQuestionCode}
              fromURL={fromURL} />
          </Modal>


        }
      </>

    );
  }
}


const mapStateToProps = (state: any) => ({
  accordianState: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianState', []),
  accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
  accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
  isComingFromQuestionComponent: _.get(state, 'contentRequestData.contentRequestAccordianData.isComingFromQuestionComponent'),
  isComingFromTest: _.get(state, 'contentRequestData.contentRequestAccordianData.isBothTabOpen', false),
  isTabOpened: _.get(state, 'contentRequestData.contentRequestAccordianData.isTabOpened'),
  progressBarForQuestion: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForQuestion', {}),
  progressBarForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForTest', {}),
  accordianTest: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTest', []),
  contentRequestData: _.get(state, 'contentRequestData.contentRequestData'),
  isBothTabOpen: _.get(state, 'contentRequestData.contentRequestAccordianData.isBothTabOpen'),
  filteredQuestionArray: _.get(state, 'contentRequestData.contentRequestAccordianData.filteredQuestionArray', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  setAccordianState: contentRequestAccordianActions.setAccordianState,
  setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
  setAccordianTouchWhileCreate: contentRequestAccordianActions.setAccordianTouchWhileCreate,
  setIsTabOpened: contentRequestAccordianActions.setIsTabOpened,
  setProgressBarForQuestion: contentRequestAccordianActions.setProgressBarForQuestion,
  setProgressBarForTest: contentRequestAccordianActions.setProgressBarForTest,
  setTestAccordian: contentRequestAccordianActions.setTestAccordian,
  setIsBothTabOpen: contentRequestAccordianActions.setIsBothTabOpen,
  setIsComingFromTest: contentRequestAccordianActions.setIsComingFromTest,
  setFilterQuestionArray: contentRequestAccordianActions.setFilterQuestionArray,
  setType: contentRequestAccordianActions.setType,
  setOverallStatus: contentRequestAccordianActions.setOverallStatus
}, dispatch);



export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(YourTaskListing));
